import adapter from './adapter';

export default Object.assign(Object.create(adapter), {
  /**
   * Возвращает информацию о приложении.
   *
   * @returns {Promise<ApiAppInfo>}
   */
  getInfo() {
    return this.getData('/app.info');
  },

  /**
   * Возвращает список публикаций с портала NormaCS.
   *
   * @param {number} [limit=1]
   * @returns {Promise<{
   *   news: Array<ApiNormacsInfoItem>,
   *   ntds: Array<ApiNormacsInfoItem>,
   *   projects: Array<ApiNormacsInfoItem>,
   *   discussions: Array<ApiNormacsInfoItem>
   * }>}
   */
  getNormacsInfo(limit = 1) {
    return this.getData('/app.normacs.info', { params: { limit } });
  },

  /**
   * Возвращает публикацию с портала NormaCS.
   *
   * @param {string} sectionId
   * @param {string} publicationId
   * @returns {Promise<ApiNormacsInfoPublication>}
   */
  getNormacsInfoPublication(sectionId, publicationId) {
    return this.getData('/app.normacs.info/publications', {
      params: {
        section: sectionId,
        id: publicationId
      }
    });
  },

  /**
   * Возвращает полезную информацию для пользователя.
   *
   * @returns {Promise<{
   *   banners: Array<Object>,
   *   links: Array<Object>
   * }>}
   */
  getUsefulInfo() {
    return this.getData('/app.useful-info');
  },

  /**
   * Возвращает массив словоформ для поиска по текстовому виду.
   *
   * @returns {Promise<{
   *   Array<String>
   * }>}
   */
  getDataForTextSearch(str) {
    return this.getData('/app.service.wordsearch', {
      params: {
        text: str
      }
    });
  }
});
